{
  "date": "{{month}} {{day}}, {{year}}",
  "docs": {
    "cip": "USA PATRIOT Act Notice",
    "cpa": "Credit Profile Authorization",
    "esign": "E-Sign Consent",
    "pp": "Privacy Policy",
    "tos": "Terms of Use",
    "uplift": {
      "lendersLink": "https://uplift.com/lenders",
      "footnotes": "<div><span>By clicking \"Let's Get Started\", I agree to </span><esignLink /><span>, </span><cpaLink /><span>, </span><ppLink /><span>, </span><tosLink /><span>, and </span><cipLink /><span>.</span> I also authorize Uplift and their lending partners to obtain my consumer credit report to present me with potential loan offers.</div>",
      "please-ensure": "<div><span>Please ensure that the information provided is complete and accurate. It will be used to verify your identity. Your rate depends upon credit score, loan amount and loan term, credit usage and credit history. Loans made through Uplift are offered by these </span> <lendersLink>Lending Partners</lendersLink><span>. Not available in all states.</span></div>"
    },
    "flexpay": {
      "lendersLink": "https://upgrade.com/flex-pay/lenders",
      "footnotes": "<div><span>By clicking \"Let's Get Started\", I agree to </span><esignLink /><span>, </span><cpaLink /><span>, </span><ppLink /><span>, </span><tosLink /><span>, and </span><cipLink /><span>.</span> I also authorize Upgrade and its subsidiaries and their lending partners to obtain my consumer credit report to present me with potential loan offers.</div>",
      "please-ensure": "<div><span>Please ensure that the information provided is complete and accurate. It will be used to verify your identity. Your rate depends upon credit score, loan amount and loan term, credit usage and credit history. Loans made through Flex Pay by Upgrade are offered by these </span> <lendersLink>Lending Partners</lendersLink><span>. Not available in all states.</span></div>"
    }
  },
  "read-only-labels": {
    "name": "Applicant",
    "phone-number": "Mobile Number",
    "email": "Email",
    "trip-dates": "Trip Dates",
    "trip-date": "Trip Date",
    "purchase-cost": "Purchase Cost",
    "loan-amount": "Loan Amount"
  },
  "estimated-payment": {
    "header": "Estimated payment",
    "from-payment": "from <payment />/month",
    "apr": "<span>Estimated calculation based on <apr /> APR, a first payment today from <downpayment />, followed by <numberofpayments>{{numberOfPayments}}</numberofpayments> loan payments.</span>"
  },
  "subvention-promo": "As low as 0% APR may be available",
  "required-fields": "All fields required",
  "regular-application": {
    "inputs": {
      "first_name": {
        "label": "First Name",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "is required*"],
          ["minLength2", "is required*"],
          ["validName", "is invalid*"]
        ]
      },
      "last_name": {
        "label": "Last Name",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "is required*"],
          ["minLength2", "is required*"],
          ["validName", "is invalid*"]
        ]
      },
      "address": {
        "label": "Home Address*",
        "isRequired": true,
        "validity": [
          ["required", "Home Address is required*", "ignore label"],
          ["minLength2", "Home Address is invalid*", "ignore label"],
          ["notEmail", "Home Address is invalid*", "ignore label"],
          ["notPOBox", "PO Box is not accepted*", "ignore label"]
        ]
      },
      "city": {
        "label": "City",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "City is required*", "ignore label"],
          ["minLength2", "City is invalid*", "ignore label"],
          ["notEmail", "City is invalid*", "ignore label"]
        ]
      },
      "region": {
        "label": "State",
        "isRequired": true,
        "showRequiredIcon": true,
        "placeholder": "Select a State",
        "validity": [
          ["required", "State is required*", "ignore label"],
          ["minLength2", "State is invalid*", "ignore label"],
          [
            "allowedRegionUS",
            "Unavailable for [value] residents*",
            "ignore label"
          ],
          ["validRegionUS", "State is invalid*", "ignore label"]
        ]
      },
      "postal_code": {
        "label": "ZIP Code",
        "isRequired": true,
        "showRequiredIcon": true,
        "mask": "00000",
        "placeholder": "55555",
        "validity": [
          ["required", "ZIP Code is required*", "ignore label"],
          ["minLength5", "ZIP Code is invalid*", "ignore label"]
        ]
      },
      "date_of_birth": {
        "label": "Date of Birth",
        "isRequired": true,
        "showRequiredIcon": true,
        "mask": "00/00/0000",
        "maxLength": 10,
        "format": "mmddyyyy",
        "placeholder": "mm/dd/yyyy",
        "srOnly": "M M D D Y Y Y Y",
        "validity": [
          ["required", "is required*"],
          ["validDate", "is invalid*"],
          ["validBirthdate", "Enter a valid birth date*", "ignore label"],
          ["isNotUnderageUS", "Must be 18+ years old*", "ignore label"]
        ],
        "postProcess": "reformatDateOfBirthUS",
        "tooltip": "<div><span>Applicant must be 18 years or older.</span></div>"
      },
      "income": {
        "label": "Annual Household Income",
        "isRequired": true,
        "optional": false,
        "showRequiredIcon": true,
        "maxLength": 9,
        "placeholder": "$50,000",
        "symbol": "$",
        "validity": [
          ["validAmount", "Enter a valid income figure*", "ignore label"]
        ],
        "postProcess": "priceInCents",
        "tooltip": "<div><span>Annual household income includes all wages and salaries before taxes. Alimony, child support or separate maintenance income need not be revealed.</span></div>"
      },
      "ssn": {
        "label": "Last 4 of SSN",
        "isRequired": true,
        "optional": false,
        "showRequiredIcon": true,
        "mask": "0000",
        "placeholder": "****",
        "length": 4,
        "maxLength": 4,
        "allowHide": true,
        "isVisible": true,
        "allowHideLabel": "Show the last 4 digits of your SSN",
        "validity": [
          ["required", "is required*"],
          ["requiredLength4", "must be 4 digits*"]
        ],
        "tooltip": "<div><span>Including your SSN will allow us to more efficiently process your financial information.</span></div>"
      },
      "email": {
        "label": "Email",
        "isRequired": true,
        "showRequiredIcon": true,
        "validity": [
          ["required", "is required*"],
          ["validEmail", "is invalid*"]
        ]
      },
      "mobile": {
        "label": "Mobile Number",
        "isRequired": true,
        "showRequiredIcon": true,
        "mask": "000-000-0000",
        "placeholder": "555-555-5555",
        "validity": [
          ["required", "is required*"],
          ["requiredLength10", "is invalid*"]
        ],
        "postProcess": "digitOnlyString",
        "tooltip": "<div><span>We need this to send you a</span><br><span>one-time SMS verification code.</span><br><span>Data and message rates may </span><br><span>apply.</span></div>"
      }
    },
    "header": "<h2>Ready to check your rate?</h2>",
    "header-with-name": "<h2>Hi {{name}}, ready to check your rate?</h2>",
    "subheader": {
      "verify-details": "Please verify the details below are correct.",
      "no-inquiry": "Checking eligibility won't affect your credit score. There is no hard inquiry.",
      "learn-more": "Learn more"
    }
  },
  "onboard-spend-application": {
    "inputs": {
      "first_name": "$t(start:regular-application.inputs.first_name)",
      "last_name": "$t(start:regular-application.inputs.last_name)",
      "address": "$t(start:regular-application.inputs.address)",
      "city": "$t(start:regular-application.inputs.city)",
      "region": "$t(start:regular-application.inputs.region)",
      "postal_code": "$t(start:regular-application.inputs.postal_code)",
      "date_of_birth": "$t(start:regular-application.inputs.date_of_birth)",
      "income": "$t(start:regular-application.inputs.income)",
      "ssn": "$t(start:regular-application.inputs.ssn)",
      "email": "$t(start:regular-application.inputs.email)",
      "mobile": {
        "label": "Mobile Number",
        "isRequired": true,
        "showRequiredIcon": true,
        "mask": "000-000-0000",
        "placeholder": "555-555-5555",
        "validity": [
          ["required", "is required*"],
          ["requiredLength10", "is invalid*"]
        ],
        "postProcess": "digitOnlyString"
      }
    },
    "header": "<h2>Ready to check your eligibility?</h2>",
    "header-with-name": "<h2>Hi {{name}}, ready to check your eligibility?</h2>",
    "subheader": {
      "verify-details": "The application takes only a minute. Please verify the details below are correct. Your loan amount should match your purchase cost.",
      "no-inquiry": "Checking eligibility won't affect your credit score. There is no hard inquiry.",
      "learn-more": "Learn more"
    }
  },
  "marketing-communication-opt-in": "Yes, I'd like to receive information about new offers and deals from Uplift.",
  "submit": "Let's Get Started",
  "notice-header-disclaimer": "<span><strong>NOTICE TO MARRIED APPLICANTS:</strong> No provision of a marital property agreement, a unilateral statement under s. 766.59 or a court decree under s. 766.70 adversely affects the interest of the creditor unless the creditor, prior to the time credit is granted, is furnished a copy of the agreement, statement or decree or has actual knowledge of the adverse provision when the obligation to the creditor is incurred.</span>"
}
